var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full", class: _vm.marginClass }, [
    _vm.text
      ? _c(
          "div",
          {
            staticClass: "text-brand-secondary-900 font-bold",
            class: _vm.textClass
          },
          [_vm._v(_vm._s(_vm.text.capitalize()))]
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "relative" },
      [
        _c(
          "scroll-gradient",
          {
            class: {
              "flex flex-wrap": _vm.wrap,
              "md_flex ml-_375 overflow-x-auto md_overflow-x-visible whitespace-no-wrap md_whitespace-normal": !_vm.wrap,
              "px-1": _vm.wrap && _vm.isWhitelabel,
              "px-1 pt-1 md_pt-2 md_px-2": _vm.wrap && !_vm.isWhitelabel
            },
            attrs: { hidden: _vm.wrap }
          },
          _vm._l(_vm.campaigns, function(campaign, index) {
            return _c("product", {
              key: _vm.generate(),
              class: [
                { "md_w-1-4 ": !_vm.wrap },
                { "w-1-2 md_w-1-3": _vm.wrap },
                { "lg_w-1-4": _vm.wrap && !_vm.threeColumns },
                { "ml-1 md_ml-_5": index === 0 && !_vm.wrap }
              ],
              attrs: {
                "hide-price": _vm.hidePrice,
                "utm-source": _vm.utmSource,
                affiliate: _vm.affiliate,
                campaign: campaign,
                "currency-info": _vm.currencyInfo,
                wrap: _vm.wrap,
                "three-columns": _vm.threeColumns,
                "is-whitelabel": _vm.isWhitelabel,
                coupon: _vm.coupon
              },
              on: {
                "hide-campaign": function($event) {
                  return _vm.$emit("hide-campaign", $event)
                }
              }
            })
          }),
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }